"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgPreviewMainImage = exports.ImgPreviewEmpty = exports.ImgPreviewDecorations = exports.ImgPreviewActions = exports.ImgPreview = void 0;
const React = require("react");
const react_router_dom_1 = require("react-router-dom");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const ImgPreviewEmpty_1 = require("./components/ImgPreviewEmpty");
const ImgPreviewMainImage_1 = require("./components/ImgPreviewMainImage");
const css = (0, cssComposer_1.default)(styles, "imgPreview");
const ImgPreviewWrapper = ({ url, className, onClick, children }) => {
    if (!url) {
        return (React.createElement("div", { onClick: onClick, className: className }, children));
    }
    if (env.webLinks) {
        return (React.createElement("a", { href: url, className: className }, children));
    }
    return (React.createElement(react_router_dom_1.NavLink, { to: url, className: className }, children));
};
/**
 * Renders a self contained image in a preview size, optionally with actions and decorations
 */
const ImgPreview = ({ clickThroughUrl, onClick, children }) => {
    /**
     * Ensures that at least either a main image or empty preview exists exists in the imgPreview component!
     */
    const x = React.Children.toArray(children).find((y) => y.type !== ImgPreviewMainImage_1.ImgPreviewMainImage || y.type !== ImgPreviewEmpty_1.ImgPreviewEmpty);
    if (typeof x === "undefined") {
        throw new Error("ImgPreview must include either a main image or an empty image");
    }
    return (React.createElement("div", { "data-test": "img-preview" },
        React.createElement(ImgPreviewWrapper, { url: clickThroughUrl, onClick: onClick, className: css("") }, children)));
};
exports.ImgPreview = ImgPreview;
var ImgPreviewActions_1 = require("./components/ImgPreviewActions");
Object.defineProperty(exports, "ImgPreviewActions", { enumerable: true, get: function () { return ImgPreviewActions_1.ImgPreviewActions; } });
var ImgPreviewDecorations_1 = require("./components/ImgPreviewDecorations");
Object.defineProperty(exports, "ImgPreviewDecorations", { enumerable: true, get: function () { return ImgPreviewDecorations_1.ImgPreviewDecorations; } });
var ImgPreviewEmpty_2 = require("./components/ImgPreviewEmpty");
Object.defineProperty(exports, "ImgPreviewEmpty", { enumerable: true, get: function () { return ImgPreviewEmpty_2.ImgPreviewEmpty; } });
var ImgPreviewMainImage_2 = require("./components/ImgPreviewMainImage");
Object.defineProperty(exports, "ImgPreviewMainImage", { enumerable: true, get: function () { return ImgPreviewMainImage_2.ImgPreviewMainImage; } });
//# sourceMappingURL=index.js.map